import script from "./SvgIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./SvgIcon.vue?vue&type=script&lang=ts&setup=true"

import "./SvgIcon.vue?vue&type=style&index=0&id=0a78b7f8&lang=scss&scoped=true"

import exportComponent from "D:\\Users\\Sean\\Documents\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a78b7f8"]])

export default __exports__